import type { IconName } from "components/Icon";

import type {
  EnergyAnalysisMixChartType,
  EnergyAnalysisTotalChartType,
  EnergyAnalysisTrendChartType,
} from "../model/types";

export const TOTAL_CHART_TYPE_ICONS: Record<EnergyAnalysisTotalChartType, IconName> = {
  barHorizontal: "SquareHalf",
  barVertical: "Barchart",
  doughnut: "Piechart",
  kpi: "Energy",
};

export const TREND_CHART_TYPE_ICONS: Record<EnergyAnalysisTrendChartType, IconName> = {
  line: "ArrowUpRight",
  stackedBar: "Barchart",
  stackedPercent: "SquareHalf",
};

export const MIX_CHART_TYPE_ICONS: Record<EnergyAnalysisMixChartType, IconName> = {
  heatmap: "GridIcon",
  sankey: "ArrowUpRight",
  sunburst: "Piechart",
  treemap: "FlatCube",
};
